var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.message)?_c('div',{staticClass:"flex items-center leading-none text-base text-green-warm-600 z-100 px-4 py-3"},[_c('i',{staticClass:"fa fa-check mb-px mr-1.5 text-xs"}),_vm._v(_vm._s(_vm.message)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }